import { render } from "./LogOutPage.vue?vue&type=template&id=c23ab09a&ts=true"
import script from "./LogOutPage.vue?vue&type=script&lang=ts"
export * from "./LogOutPage.vue?vue&type=script&lang=ts"

import "./LogOutPage.vue?vue&type=style&index=0&id=c23ab09a&lang=sass"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__